import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const TwitterIcon: FunctionComponent<IconProps> = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_2785_91517)'>
      <path fillRule='evenodd' clipRule='evenodd' d='M32 0H0V32H32V0ZM23.3273 12.8558C23.3273 12.6981 23.3273 12.5419 23.3161 12.3856C24.0546 11.8709 24.693 11.2337 25.1998 10.5022C24.5113 10.7967 23.7803 10.9896 23.032 11.0746C23.8199 10.6203 24.4097 9.90538 24.6915 9.06375C23.95 9.48709 23.1397 9.78587 22.2942 9.94642C20.865 8.48275 18.4737 8.4122 16.9533 9.78875C15.9725 10.6765 15.5569 11.9997 15.8611 13.2625C12.8255 13.1164 9.99766 11.7355 8.08104 9.46405C7.07937 11.1257 7.59067 13.251 9.2494 14.3187C8.6484 14.3014 8.06086 14.1452 7.5361 13.8637V13.9098C7.5361 15.6405 8.80314 17.1308 10.5643 17.4735C10.0089 17.6197 9.42581 17.6413 8.85995 17.5362C9.3548 19.0171 10.7713 20.0315 12.3867 20.0611C11.0494 21.0726 9.39816 21.6219 7.69831 21.6205C7.39781 21.6198 7.09806 21.6025 6.7998 21.5679C8.52656 22.6349 10.5351 23.2008 12.5863 23.1979V23.2008C19.5299 23.2008 23.3273 17.66 23.3273 12.8558Z' fill='currentColor' />
    </g>
    <defs>
      <clipPath id='clip0_2785_91517'>
        <rect width='32' height='32' rx='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default TwitterIcon;



